import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";
function Home() {
    return (
        <div className="HomeContainer">
            <h1>Three JS Code Along</h1>
            Full Series - <a target="_blank" href="https://medium.com/@jerryjohnthomas/list/react-three-js-0cbca8c9d57d?source=user_lists---------1-------0cbca8c9d57d---------------------">here</a>
            <h3> Season 1</h3>
            <Link to="/s1e1">Episode 1 - Mesh </Link> <br />
            <Link to="/s1e2">Episode 2 - Interactive Mesh </Link> <br />
            <Link to="/s1e3">Episode 3 - Create an Eval Function (soon)</Link> <br />
            <br />
            <br />
            <div> PS: I know that this looks ugly but this works for now</div>
        </div>
    );
}

export default Home;
